import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';
import { LocalizedText } from 'bernie-l10n';

import { UitkButtonSize, UitkFloatingFullWidthButton } from 'uitk-react-button';
import { UitkScrim, UitkScrimType } from 'uitk-react-scrim';

export interface SearchFormBottomSectionProps {
  buttonRef?: any;
}

const UitkFloatingFullWidthButtonTracked = ClickTracker(UitkFloatingFullWidthButton);

export const SearchFormBottomSection: React.FunctionComponent<SearchFormBottomSectionProps> = ({ buttonRef }) => (
  <UitkScrim type={UitkScrimType.BUTTON}>
    <UitkFloatingFullWidthButtonTracked
      data-stid="submit-hotel-filters"
      domRef={buttonRef}
      type="submit"
      isFullWidth={true}
      size={UitkButtonSize.LARGE}
      rfrr="FilterControlDone"
      linkName="done search filters dialog"
    >
      <LocalizedText message="hotels.searchResults.filtersDialog.submitButton.label" />
    </UitkFloatingFullWidthButtonTracked>
  </UitkScrim>
);

SearchFormBottomSection.displayName = 'SearchFormBottomSection';
